export const siteConfigurationSelector = state => state.entities.siteConfigurations;
